import { useUpdateGuest } from "./useGuests";
import { fileService } from "@/services/ServiceRegistry";
import { GuestFormData } from "../utils/guestSchema";

export const useGuestUpdate = () => {
  const updateGuestMutation = useUpdateGuest();

  const handleGuestUpdate = async (
    guestId: string,
    guestData: GuestFormData,
    photoId?: string,
    photoFile?: File,
  ) => {
    try {
      let createdPhotoId;
      if (photoFile) {
        try {
          if (photoId) {
            await fileService.updateFileWithPresignedUrl(photoId, photoFile);
          } else {
            createdPhotoId =
              await fileService.uploadFileWithPresignedUrl(photoFile);
          }
        } catch (photoError) {
          console.error("Failed to upload photo:", photoError);
        }
      }

      guestData.photoId = createdPhotoId || photoId;
      await updateGuestMutation.mutateAsync({
        id: guestId,
        data: { ...guestData },
      });
    } catch (error) {
      console.error("Failed to update guest:", error);
    }
  };

  return {
    handleGuestUpdate,
    isLoading: updateGuestMutation.isPending,
    error: updateGuestMutation.error,
  };
};
